import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Container } from '@sainsburys-tech/luna-grid'

const GlobalBar = ({ element, children, className, label, ...rest }) => {
  const Element = element

  return (
    <Element
      {...rest}
      className={classnames('ln-c-header__global-bar', className)}
      aria-label={label}
    >
      <Container className="ln-c-header__global-bar-inner">
        {children}
      </Container>
    </Element>
  )
}

GlobalBar.propTypes = {
  element: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.func,
    PropTypes.object,
  ]),
  children: PropTypes.node,
  className: PropTypes.string,
  /** Aria label used to give greater context of navigation to screen reader users */
  label: PropTypes.string,
}

GlobalBar.defaultProps = {
  element: 'div',
  children: undefined,
  className: undefined,
  label: undefined,
}

GlobalBar.displayName = 'HeaderGlobalBar'

export default GlobalBar
